import { render, staticRenderFns } from "./BlockBlockQuote.vue?vue&type=template&id=44c8c28c&"
import script from "./BlockBlockQuote.vue?vue&type=script&lang=js&"
export * from "./BlockBlockQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports